<template>
    <BaseTemplate app-name="Configurações" page-title="">
        <template #content>
            <div class="min-h-screen flex flex-col bg-slate-200 dark:bg-gray-900">
                <!-- Campo de Pesquisa -->
                <div class="p-6">
                    <input v-model="searchQuery" type="text" placeholder="Pesquisar configurações..."
                        class="w-full p-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
                <!-- Conteúdo principal -->
                <div class="flex-1 p-6 min-h-full">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <!-- Cards filtrados -->
                        <div v-for="item in filteredItems" :key="item.title"
                            class="bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer border border-gray-200 dark:border-gray-700">
                            <a :href="item.href" class="block h-full">
                                <div class="p-6 flex items-center space-x-4">
                                    <div
                                        class="p-2 rounded-lg flex items-center justify-center"
                                        :style="{ backgroundColor: 'var(--clinic-btn-bg-hover)' }">
                                        <component :is="getIcon(item.iconName)"
                                            class="h-6 w-6" :style="{ color: 'var(--clinic-icon-color)' }" />
                                    </div>
                                    <div class="space-y-1 flex-1">
                                        <h3 class="text-xl font-semibold text-gray-800 dark:text-gray-100">
                                            {{ item.title }}
                                        </h3>
                                        <p class="text-sm text-gray-600 dark:text-gray-300">
                                            {{ item.description }}
                                        </p>
                                    </div>
                                </div>
                                <div class="px-6 pb-4">
                                    <div class="flex justify-end">
                                        <span class="font-medium hover:underline" :style="{ color: 'var(--clinic-font-color)' }">
                                            Configurar →
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <!-- Mensagem caso nenhum item seja encontrado -->
                        <div v-if="filteredItems.length === 0 && searchQuery !== ''"
                            class="col-span-full text-center text-gray-500 dark:text-gray-400">
                            Nenhum item encontrado para "{{ searchQuery }}".
                        </div>
                    </div>
                </div>
            </div>
            <p class="text-center text-sm mb-11 mt-10 text-gray-500 dark:text-gray-400">
                Desenvolvido por Tecnologia da Informação - CCDTI © Todos os direitos reservados
            </p>
        </template>
    </BaseTemplate>
</template>

<script setup>
import  BaseTemplate from '../templates/BaseTemplate.vue';  // Correction in import
import { ref, onMounted, computed} from 'vue';
import { useUserStore } from '@/stores/userStore'
import {
  LayoutDashboard,
  Users,
  Calendar,
  Ear,
  Hospital,
  UsersRound,
  Hammer,
  House,
  Webhook,
  FileSpreadsheet,
  IdCard,
  HandCoins,
  Stethoscope,
  Activity,
  ClipboardList,
  Handshake,
  Package,
  Bell,
  CalendarPlus2,
  Pill,
  Info,
  Pencil,
  Tv,
  Utensils,
  HeartHandshake,
  Settings
} from 'lucide-vue-next';

// Dados e estado da pesquisa
const searchQuery = ref("");

const userStore = useUserStore()
const userGroups = computed(() => userStore.grupos || [])

// Dados dos itens
const configItems = [
    {
        title: "Usuários",
        description: "Administre contas de usuário",
        iconName: "Users",
        href: "/config/users",
        visibleFor: ["superadmin"]
    },
    {
        title: "Grupos",
        description: "Organize usuários em grupos",
        iconName: "UsersRound",
        href: "/config/groups",
        visibleFor: ["superadmin"]
    },
    {
        title: "Permissões de Grupo",
        description: "Gerencie as permissões de cada grupo de usuários do sistema.",
        iconName: "UsersRound",
        href: "/settings/permissoesgrupo",
        visibleFor: ["superadmin"]
    },
    {
        title: "Configurações da Clínica",
        description: "Gerencie as configurações da sua clínica",
        iconName: "Settings",
        href: "/settings/clinic",
        visibleFor: ["superadmin"]
    },
    {
        title: "Agendas",
        description: "Gerencie as suas agendas",
        iconName: "CalendarPlus2",
        href: "/settings/schedule",
        visibleFor: ["superadmin"]
    },
    {
        title: "Serviços",
        description: "Gerencie os seus serviços",
        iconName: "HeartHandshake",
        href: "/settings/services",
        visibleFor: ["superadmin"]
    },
    {
        title: "Anamneses",
        description: "Gerencie as anamneses",
        iconName: "ClipboardList",
        href: "/settings/anamnesis",
        visibleFor: ["superadmin"]
    },
    {
        title: "Convênios",
        description: "Gerencie os seus convênios",
        iconName: "Handshake",
        href: "/settings/insurances",
        visibleFor: ["superadmin"]
    },
    {
        title: "Máscara de Laudos",
        description: "Gerencie as suas máscaras de laudo globais",
        iconName: "Pencil",
        href: "/settings/mask",
        visibleFor: ["superadmin"]
    },
    {
        title: "Salas",
        description: "Gerencie as suas salas",
        iconName: "House",
        href: "/settings/rooms",
        visibleFor: ["superadmin"]
    },
    {
        title: "Chamadores",
        description: "Gerencie o chamadores de sua clinica",
        iconName: "Tv",
        href: "/settings/monitor",
        visibleFor: ["superadmin"]
    },
    {
        title: "Médicos",
        description: "Gerencie os médicos",
        iconName: "Stethoscope",
        href: "/settings/doctors",
        visibleFor: ["superadmin"]
    },
   // {
     //   title: "WebHooks",
      //  description: "Gerencie os seus webhooks",
      //  iconName: "Webhook",
      //  href: "/settings/webhook",
      //  visibleFor: ["superadmin"]
   // },
  ////  {
   //     title: "Notificações",
    //    description: "Gerencie as notificações",
    //    iconName: "Bell",
    //    href: "/settings/notifications",
    //    visibleFor: ["superadmin"]
  //  },
    {
        title: "Auditoria",
        description: "Auditoria de alterações no sistema",
        iconName: "Ear",
        href: "/settings/audit",
        visibleFor: ["superadmin", "auditoria"]
    },
];

const filteredItems = computed(() =>
    configItems.filter((item) => {
        // Filtro pela pesquisa
        const searchOk =
            item.title.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
            item.description.toLowerCase().includes(searchQuery.value.toLowerCase());
        // Se o item tiver "visibleFor", verifique se o usuário está em pelo menos um grupo permitido.
        const allowed =
            !item.visibleFor ||
            item.visibleFor.some((group) => userGroups.value.includes(group));
        return searchOk && allowed;
    })
);

// Função para obter ícone com base no nome
const getIcon = (iconName) => {
  const icons = {
      Calendar,
      Users,
      Hospital,
      UsersRound,
      Handshake,
      Pencil,
      Hammer,
      FileSpreadsheet,
      HeartHandshake,
      Webhook,
      Ear,
      ClipboardList,
      CalendarPlus2,
      IdCard,
      HandCoins,
      House,
      Activity,
      Settings,
      LayoutDashboard,
      Stethoscope,
      Package,
      Tv,
      Pill,
      Bell,
      Info,
      Utensils
  };
  return icons[iconName] || null;
};

onMounted(() => {

});
</script>

<style scoped>
.tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.tabs button {
  padding: 0.5rem 1.5rem;
  border: none;
  background: #f3f4f6;
  border-radius: 8px 8px 0 0;
  font-weight: 500;
  cursor: pointer;
  color: #22223b;
  transition: background 0.2s;
}
.tabs button.active {
  background: #059669;
  color: #fff;
}
</style>
